
export default {
    Short : 'short',
    Long : 'long'
}
